export default __webpack_public_path__ + "static/media/rubbishBinWhite.3a901196.svg";